import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./services/axiosAuthInterceptor"; // DVS-1535: attach bearer token to admin reporting API calls

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
